import * as React from "react";
import {
  TextField,
  PrimaryButton,
  IButtonProps,
  ITextFieldProps,
  MessageBar,
  MessageBarType,
} from "office-ui-fabric-react";
import { escape as base64Escape, encode as base64Encode } from "base64-url";
import { v4 as uuid } from "uuid";
import { sha256 } from "hash.js";
import { APIUrls, ImageUrls } from "../environments/ConfigDetails";
import axios from "axios";

export interface SignInProps {}

export interface SignInState {
  workspaceURLPrefix: string;
  workspaceURLtld: string;
  isEmptyField: boolean;
  isWorkspaceURLInvalid: boolean;
}

function signInDialog(url) {
  console.log("attempting to open dialog...");
  Office.context.ui.displayDialogAsync(
    url,
    { height: 80, width: 40, promptBeforeOpen: true },
    function (asyncResult) {
      console.log("result from dialog...", asyncResult);
      if (
        asyncResult.status === Office.AsyncResultStatus.Failed ||
        asyncResult.error
      ) {
        console.error(
          asyncResult.error.code + ": " + asyncResult.error.message
        );
      }
      let dialog = asyncResult.value;
      dialog.addEventHandler(
        Office.EventType.DialogMessageReceived,
        ({ message }: any) => {
          dialog.close();
          window.location.href = message;
        }
      );
    }
  );
}

class SignIn extends React.Component<SignInProps, SignInState> {
  constructor(props, {}) {
    super(props, {});
    this.state = {
      workspaceURLPrefix: "",
      workspaceURLtld: "com",
      isEmptyField: false,
      isWorkspaceURLInvalid: false,
    };
  }
  componentDidMount() {
    let settings = Office.context.roamingSettings;
    if (typeof settings.get("WorkspaceURLPrefix") !== "undefined") {
      let url = settings.get("WorkspaceURLPrefix");
      this.setState({ workspaceURLPrefix: url });
    } else {
      this.setState({ workspaceURLPrefix: "" });
    }
  }
  render() {
    return (
      <div>
        {this.state.isEmptyField && (
          <MessageBar
            className="msg-bar"
            messageBarType={MessageBarType.error}
            isMultiline={true}
          >
            <span
              style={{
                fontFamily: "Lato",
                fontWeight: "normal",
                fontSize: 14,
              }}
            >
              {"You must fill in workspace url"}
            </span>
          </MessageBar>
        )}
        {this.state.isWorkspaceURLInvalid && (
          <MessageBar
            className="msg-bar"
            messageBarType={MessageBarType.error}
            isMultiline={true}
          >
            <span
              style={{
                fontFamily: "Lato",
                fontWeight: "normal",
                fontSize: 14,
              }}
            >
              {"Workspace not found"}
            </span>
          </MessageBar>
        )}
        <div
          className="ms-Grid"
          dir="ltr"
          style={{
            position: "absolute",
            margin: "auto",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            height: "285px",
            textAlign: "center",
          }}
        >
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
              <img
                src={ImageUrls.simpleLegalIcon}
                style={{
                  marginLeft: "auto",
                  marginRight: "auto",
                  display: "block",
                }}
              />
              <br />

              <h2
                style={{
                  fontFamily: "Lato",
                  color: "#0E3A6E",
                  paddingLeft: "10px",
                }}
              >
                Enter your workspace URL
              </h2>
              <br />
              <br />
              <br />
            </div>
          </div>
          <br />
          <div
            className="ms-Grid-row"
            style={{ width: "100%", display: "flex" }}
          >
            <TextField
              className="ms-Grid-col ms-sm8 ms-md8 ms-lg8"
              style={
                this.state.workspaceURLPrefix
                  ? {
                      fontFamily: "Lato",
                      fontSize: 14,
                      fontWeight: "normal",
                      textAlign: "right",
                      color: "#0E3A6E",
                      //width: "65%"
                    }
                  : {
                      fontFamily: "Lato",
                      fontSize: 14,
                      fontWeight: "normal",
                      textAlign: "left",
                      //width: "65% !important"
                    }
              }
              placeholder={`your-workspace-url`}
              value={this.state.workspaceURLPrefix}
              onChange={this.workspacePrefixValueChanged}
              onKeyDown={this.textBoxKeyDown}
            />
            <span
              className="ms-Grid-col ms-sm4 ms-md4 ms-lg4"
              style={{
                fontFamily: "Lato",
                fontSize: 14,
                fontWeight: "normal",
                lineHeight: "32px",
                paddingLeft: 0,
                paddingRight: 0,
              }}
            >
              .simplelegal.
            </span>
            <select
              onChange={this.workspaceTLDValueChanged}
              style={{
                backgroundColor: "white",
                border: "1px solid rgb(100, 100, 100)",
              }}
            >
              <option value="com">com</option>
              <option value="dev">dev</option>
              <option value="io">io</option>
            </select>
          </div>
          <br />
          <br />
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
              <PrimaryButton
                data-automation-id="continue"
                title="Continue"
                style={{
                  backgroundColor: "#0E3A6E",
                  width: "100%",
                }}
                onRenderText={this.onRenderBtnText}
                onClick={this.checkWorkspaceUrlIsValid}
              >
                Continue to SimpleLegal
              </PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    );
  }
  onRenderBtnText = (_props: IButtonProps): JSX.Element => {
    return (
      <span
        style={{
          textAlign: "center",
          fontFamily: "Lato",
          fontSize: 16,
          fontWeight: "normal",
        }}
      >
        Continue to SimpleLegal
      </span>
    );
  };
  onRenderTxtSuffix = (_props: ITextFieldProps): JSX.Element => {
    return (
      <span
        style={
          Office.context.mailbox.diagnostics.hostName === "Outlook"
            ? {
                textAlign: "center",
                fontFamily: "Lato",
                fontSize: 14,
                fontWeight: "normal",
                paddingRight: 60,
              }
            : {
                textAlign: "center",
                fontFamily: "Lato",
                fontSize: 14,
                fontWeight: "normal",
              }
        }
      >
        .simplelegal.
      </span>
    );
  };
  //save workspace URL
  saveWorkSpaceURL = () => {
    let { workspaceURLPrefix, workspaceURLtld } = this.state;
    let settings = Office.context.roamingSettings;
    console.log("saving workspaceURLPrefix...", workspaceURLPrefix);
    settings.set("WorkspaceURLPrefix", workspaceURLPrefix);
    console.log("saving WorkspaceURLtld...", workspaceURLtld);
    settings.set("WorkspaceURLtld", workspaceURLtld);
    settings.saveAsync(function (asyncResult) {
      console.log("settingsSaveSuccess", asyncResult);
      if (asyncResult.status == Office.AsyncResultStatus.Failed) {
        console.error("Outlook failed to save the WorkspaceURLPrefix...");
      } else {
        const codeVerifier = uuid();
        const encodedCodeChallenge = base64Escape(
          base64Encode(sha256().update(codeVerifier).digest())
        );

        localStorage.setItem("slCodeVerifier", codeVerifier);
        console.log("codeVerifier", codeVerifier);
        console.log("popping up signin dialog...");
        signInDialog(
          APIUrls.urlForAuthorization({
            workspace: workspaceURLPrefix,
            tld: workspaceURLtld,
            codeChallenge: encodedCodeChallenge,
          })
        );
      }
    });
    this.setState({ isEmptyField: false, isWorkspaceURLInvalid: false });
  };
  //workspace on changed
  workspacePrefixValueChanged = (event) => {
    this.setState({
      workspaceURLPrefix: event.target.value,
      isEmptyField: false,
      isWorkspaceURLInvalid: false,
    });
  };
  //tld on changed
  workspaceTLDValueChanged = (event) => {
    this.setState({
      workspaceURLtld: event.target.value,
      isEmptyField: false, //we don't know this anymore.
      isWorkspaceURLInvalid: false, //could well still be
    });
  };
  //key down function for matter search text box
  addressChangeKeyDown = (event) => {
    if (this.state.workspaceURLtld) {
      if (event.keyCode == 13 && event.shiftKey == false) {
        //non-shift enter key presses
        this.checkWorkspaceUrlIsValid();
      }
    }
  };
  textBoxKeyDown = (event) => {
    if (this.state.workspaceURLPrefix) {
      if (event.keyCode == 13 && event.shiftKey == false) {
        //non-shifted enter key press.
        this.checkWorkspaceUrlIsValid();
      }
    }
  };
  checkWorkspaceUrlIsValid = () => {
    let { workspaceURLPrefix, workspaceURLtld } = this.state;
    try {
      if (workspaceURLPrefix) {
        axios
          .get(
            APIUrls.urlForBucketCredentials(workspaceURLPrefix, workspaceURLtld)
          )
          .then((response) => {
            console.info("Workspace is valid...", response);
          })
          .catch((err) => {
            if (typeof err.response !== "undefined") {
              // a 401 means the user is not authenticated, so we need to pop up the signin dialog
              if (err.response.status === 401) {
                this.saveWorkSpaceURL();
              } else {
                this.setState({ isWorkspaceURLInvalid: true });
              }
            } else {
              this.setState({ isWorkspaceURLInvalid: true });
            }
          });
      } else {
        this.setState({ isEmptyField: true });
      }
    } catch (ex) {
      this.setState({ isWorkspaceURLInvalid: true });
    }
  };
}

export default SignIn;
